module.exports = __webpack_public_path__ + "static/media/logo.e748a805.svg";